import { axios } from '@/utils/request';

let Api = {
  alipayQrcode: '/auth/api/third-system/quota-purchase', // 支付宝当面付
  alipayStatus: '/auth/pay/trade-query', // 支付宝订单状态查询
  alipayClose: '/pay/trade-close', // 支付宝取消订单
};


// 支付宝当面付
export const alipayQrcodeApi = (params) => {
  return axios.post(Api.alipayQrcode, params);
};

// 支付宝订单状态查询
export const alipayStatusApi = (params) => {
  return axios.get(Api.alipayStatus, { params });
}

// 支付宝取消订单
export const alipayCloseApi = (params) => {
  return axios.get(Api.alipayClose, { params });
}
